import React from 'react'
import Page from 'layouts/Page'
import Masthead, { MastheadOverlap } from 'layouts/Masthead'
import Container from 'layouts/Container'
import Box, { BoxSection } from 'layouts/Box'
import { Node, md } from 'djedi-react'

export default () => (
  <Page title="Frågor & svar" plain>
    <Masthead overlap plain>
      <Container size="medium">
        <h1>
          <Node uri="faq/heading">Vanliga frågor &amp; svar</Node>
        </h1>
      </Container>
    </Masthead>
    <MastheadOverlap>
      <Container size="medium">
        <Box>
          <BoxSection>
            <Node uri="faq/text.md">
              {md`
                #Om friendtivity
                #####Vad är friendtivity?

                friendtivity AB grundades av trebarnsmammorna Lena
                Wijkström och Louise Wachtmeister med insikten att
                fritidsaktiviteter för barn borde kunna göras mer
                flexibla, lättillgängliga och prisvärda.

                friendtivity har som vision att erbjuda
                stimulerande och roliga aktiviteter inom olika
                intressen för barn och ungdomar efter skolan, på
                helgen eller loven i små grupper. Våra duktiga
                ledare har varierande bakgrund och expertis, vilket
                speglas vi våra olika grupper och aktiviteter som
                kan vara allt från t.ex. musik, kultur, idrott,
                språk, skapande, till e-sport och programmering.

                Genom friendtivities plattform kan du på ett smidigt sätt hitta, boka och betala för en aktivitet.
                friendivity har som mål att aktiviteterna ska bidra till att fler barn och unga i Sverige får möjlighet att ha en rolig och meningsfull fritid. Tillsammans med gamla eller nya kompisar ska varje barn kunna hitta sitt sammanhang.
                Vårt långsiktiga mål är att fler barn och ungdomar ska ha möjlighet att förbättra sina framtidsutsikter och att vi därigenom bidrar till ett mer inkluderande och samhälle.

                #####Vad är en friendtivity?
                En friendtivity är precis vad det låter som – en aktivitet kring ett intresse i en liten grupp med gamla eller nya kompisar. Alla friendtivities sker hemma hos någon i gruppen, ledd av en av våra anställda ledare. Ledaren hämtar såklart vid skolan om man vill.
                Fördelen med att ha aktiviteten hemma är att man kan använda det man redan har tillgång till, t ex ett piano eller en symaskin eller använda ett rymligt vardagsrum som dansgolv.

                #####Hur är en friendtivity utformad?
                Det är våra ledares passion och engagemang kring deras intresseområde och barnens nyfikenhet som formar aktiviteten. Grunden för alla aktiviteter är kreativitet, gruppdynamik och vänskap. Alla våra ledare har gått friendtivitys utbildning där man får lära sig hur man skapar kreativa grupper, inspirerande och utvecklande miljöer samt hur man får till en bra gruppdynamik.

                #####Vad är målet med en friendtivity?
                Det viktigaste är att barnen känner sig inspirerade och utvecklas inom ett specifikt intresse och hittar sitt sammanhang.

                #####Var finns friendtivity?
                friendtivity lanserades i Stockholm, men kommer inom kort etableras i fler stora städer i Sverige.

                #####Varför ska jag använda friendtivity?
                Barn mår bra av att utveckla sina intressen tillsammans med kompisar. På så sätt kan barnen hitta sina sammanhang och det stärker självkänslan och ökar välbefinnandet. Det leder i sin tur till fler positiva effekter. Uppmuntra ditt barn kring ett befintligt intresse och hitta en grupp eller skapa en egen här hos oss.

                #####Kan en aktivitet kring samma intresse vara olika utformad?
                Ja, alla barn och grupper skapar unika gruppdynamiker. Varje aktivitet utformas av ledaren tillsammans med barnen och den förälder som är gruppadmin.

                #####Hur gammalt måste mitt barn vara?
                friendtivity välkomnar alla barn och ungdomar i grundskolan, dvs du måste ha börjat i förskoleklass för att delta.

                #Plattformen och bokning
                #####Vad kan man använda plattformen till?
                Plattformen är till för dig som förälder och här kan du:

                1. Hitta, söka och bli matchad med ledare för olika friendtivities baserat på var du bor och vilket
                   intresse ditt barn har.
                2. Skapa och hitta grupper (det finns både “öppna” och “stängda”).
                3. Boka och betala för friendtivityn.

                Sökfunktionen fungerar även när du är utloggad. För att bli matchad med en ledare med specifika kunskaper behöver du som förälder registrera din profil på plattformen.

                #####Kostar det något att registrera ett konto?
                Nej, det kostar inget.

                #####Kan andra se min profil?
                Det är bara den ledare och de föräldrar som du bjuder in till gruppen när du har gjort en bokning som kan se din profil.

                #####Kan jag vara trygg med att lämna mina uppgifter?
                Ja, friendtivity behandlar alla dina uppgifter konfidentiellt och i enlighet med GDPR.

                #####Hur bokar jag en friendtivity?
                Som förälder behöver du först skapa ett konto på friendtivity. Därefter kan du boka en ledare direkt via ledarens kalenderfunktion. Du skapar sedan en grupp och bjuder in andra föräldrar till ditt barns kompisar via mail eller Facebook. Den som skapar en grupp blir gruppadmininistratör (“gruppadmin”).
                En ledare blir bokad först när det antal gruppmedlemmar som gruppen är avsedd för har accepterat inbjudan och betalat för friendtivityn.
                Det är först-till-kvarn principen som gäller, dvs de föräldrar som först går med i gruppen och betalar får plats.

                #####Vad är en gruppadmin?
                Den som skapar en grupp blir gruppadministratör, sk “gruppadmin”. Det är hemma hos gruppadmin som aktiviteten sker och det är även gruppadmin som håller i kommunikationen med ledaren.

                #####Om jag skapar en grupp och är gruppadmin sker då alltid aktiviteten i mitt hem?
                Nej, du kan komma överens med en annan förälder att aktiviteten är hemma hos dem istället. Vi rekommenderar att man har en reserv i gruppen där aktiviteten skulle kunna vara istället, om t.ex. gruppadmins barn blir sjukt.

                #####Får gruppadmin någon kompensation?
                Ja, eftersom friendtivityn sker hemma hos gruppadmin får man en rabatt för sitt barn.

                #####Hur långt innan måste jag boka?
                Eftersom många av våra ledare är duktiga studenter får de flesta reda på sin tillgänglighet i början på terminen. Därför behöver man inte stå i kö eller boka innan en termin börjar. Du bokar när och hur du vill, men vi rekommenderar att vara snabb eftersom våra populära ledare fort blir uppbokade.

                #####Hur lång är en friendtivity?
                En friendtivity är min 2 timmar men kan givetvis vara längre om man vill och om ledaren är tillgänglig.

                #####Hur många tillfällen är en friendtivity?
                En friendtivity är som en regelbunden fritidsaktivitet (1 ggr/vecka). Man kan boka en friendtivity för minst 4 veckor i följd och som mest 16 veckor.
                Man kan givetvis boka fler än en friendtivity per vecka och då gör man helt enkelt en till bokning.

                #####Vad kostar en friendtivity?
                Priset för en friendtivity varierar beroende på antal tillfällen och antal gruppmedlemmar. Priset är alltid baserat på ett timpris/deltagare.

                #####Hur betalar man för en friendtivity?
                Du betalar hela beloppet snabbt och enkelt när du bokar. Vi samarbetar med Klarna och de kan hjälpa till om man t ex vill delbetala. <a href="https://www.klarna.com/se/villkor-2/">Här</a> finns deras villkor.

                #####Måste jag ha något speciellt hemma?
                Varje aktivitet skapas efter behov och förutsättningar. Gruppadmin och ledare stämmer av tillsammans om det behövs någon särskild utrustning eller material. Om man behöver köpa in något så delar man på den kostnaden i gruppen.

                #####Vad händer när friendtivityn är slut?
                När aktiviteten är slut så hämtar man sina barn precis som man skulle gjort vid vilken fritidsaktivitet som helst. Tänk på att respektera tiderna.

                #####Hur hittar jag andra som letar efter samma typ av aktivitet?
                Du skapar då en så kallad “öppen grupp” och markerar vilket intresse det handlar om och var du finns. Den öppna gruppen kommer sedan att synas på kartvyn som en grön markering. Vi gör vårt bästa för att de öppna grupperna ska bli så synliga som möjligt, så att man så fort som möjligt kan hitta fler medlemmar och boka in en ledare och komma igång.

                #####Vad är en stängd grupp?
                En stängd grupp betyder att det är gruppadmin som bjuder in utvalda personer till gruppen och aktiviteten.

                #####Hur många barn är det i en grupp?
                Mellan 2 och 4 barn.

                #####Måste alla barn vara i samma ålder?
                Nej, det bestämmer gruppadmin.

                #Våra ledare
                #####Vilka jobbar på friendtivity?
                Hos friendtivity jobbar passionerade, engagerade ledare som drivs av att vara goda förebilder och dela med sig av sin kunskap och glädje inom sitt intresseområde. Ofta är våra ledare duktiga studenter som vill ha ett extrajobb. Alla våra ledare är anställda av friendtivity AB och eftersom vi är mycket noggranna i vår rekryteringsprocess kan du som förälder alltid känna dig helt trygg.

                #####Hur ser friendtivitys rekryteringsprocess ut?

                1. En potentiell ledare (måste ha fyllt 18 år) ansöker om att bli ledare hos friendtivity genom att skapa ett konto på friendtivity.se. och registrera en profil.
                2. Därefter går friendtivity igenom profilen och dokument samt gör en bakgrundskontroll via vår samarbetspartner <a href="https://www.verifera.se/">Verifiera</a>. Vår policy är att en Ledare inte får ha någon som helst form av fällande brottmålsdom mot sig.
                3. Som tredje steg kallas ledaren till en personlig intervju.

                Innan sitt första uppdrag skall Ledaren ha genomgått friendtivity’s introduktionsprogram. Programmet fokuserar hur man skapar kreativa miljöer, hanterar gruppdynamik samt barns utveckling.

                #####Har era ledare HLR utbildning?
                Vissa ledare har HLR utbildning, vilket syns i deras profil. Vi strävar efter att så många som möjligt av våra ledare har en HLR utbildning och håller kontinuerligt HLR kurser för våra ledare.

                #####Har era ledare körkort?
                Vissa ledare har körkort, viket syns i deras profil.

                #####Vad har ni för försäkring?
                Alla våra ledare täcks av en ansvarsförsäkring och alla barn omfattas av en olycksfallsförsäkring genom IF.

                #Vad händer om det oförutsedda sker?

                #####Vad händer om gruppadmins familj/barn är sjuka?
                Vid sjukdom av gruppadmin familj/barn kan friendtivityn hållas hos en annan gruppmedlem. Det åligger gruppadmin att snarast möjligt komma överens med ledaren och gruppen om en alternativ plats. Vi rekommenderar att man i en grupp alltid utser en gruppadmin reserv där friendtivityn kan hållas om ordinarie gruppadmins familj/barn blir sjukt.

                #####Vad händer om ledaren blir sjuk?
                Ledaren meddelar gruppadmin så fort som möjligt på chatten eller på det sätt som gruppen kommit överens om. Därefter kontaktar ledaren friendtivity så fort som möjligt.
                friendtivity gör sitt absolut bästa för att hitta en vikarie som kan hämta på skolan och gå hem med barnen och hålla en aktivitet inom ett liknande intresse.

                #####Vad händer om mitt barn är sjuk?
                Precis som vid andra aktiviteter så missar man ibland ett tillfälle pga sjukdom.

                #####Vad händer om det sker en olycka?
                Om det sker en olycka av något slag är vi måna om att hjälpa till så fort som möjligt.

                Kontakta då vår kundsupport antingen på <a href="mailto:info@friendtivity.se">info@friendtivity.se</a> eller tel: 08-410 203 50.

                #Övrigt
                #####Kan jag använda RUT-avdrag?
                Nej, konstigt nog kan man inte det. Trots att tjänsten utförs i hemmet gäller inte RUT eftersom våra ledare har specialkunskaper. Vi hoppas kunna ändra på det så småningom.

                #####Varför är momsen så hög?
                Fråga Skatteverket 🙂
              `}
            </Node>
          </BoxSection>
        </Box>
      </Container>
    </MastheadOverlap>
  </Page>
)



// WEBPACK FOOTER //
// ../source/static/FAQ.js